var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',[_c('li',{domProps:{"textContent":_vm._s(_vm.label)},on:{"click":function($event){return _vm.$emit('change', _vm.activeItem)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }